import { b as R } from "../_baseSlice-4d543985.mjs";
import { t as g } from "../toString-3b91b335.mjs";
import "../isArray-0d9c7aaa.mjs";
function v(r, e, o) {
  var u = r.length;
  return o = o === void 0 ? u : o, !e && o >= u ? r : R(r, e, o);
}
var C = "\\ud800-\\udfff", S = "\\u0300-\\u036f", A = "\\ufe20-\\ufe2f", $ = "\\u20d0-\\u20ff", h = S + A + $, j = "\\ufe0e\\ufe0f", y = "\\u200d", F = RegExp("[" + y + C + h + j + "]");
function s(r) {
  return F.test(r);
}
function M(r) {
  return r.split("");
}
var i = "\\ud800-\\udfff", O = "\\u0300-\\u036f", U = "\\ufe20-\\ufe2f", k = "\\u20d0-\\u20ff", x = O + U + k, H = "\\ufe0e\\ufe0f", J = "[" + i + "]", f = "[" + x + "]", n = "\\ud83c[\\udffb-\\udfff]", T = "(?:" + f + "|" + n + ")", c = "[^" + i + "]", d = "(?:\\ud83c[\\udde6-\\uddff]){2}", l = "[\\ud800-\\udbff][\\udc00-\\udfff]", V = "\\u200d", m = T + "?", p = "[" + H + "]?", E = "(?:" + V + "(?:" + [c, d, l].join("|") + ")" + p + m + ")*", W = p + m + E, Z = "(?:" + [c + f + "?", f, d, l, J].join("|") + ")", q = RegExp(n + "(?=" + n + ")|" + Z + W, "g");
function w(r) {
  return r.match(q) || [];
}
function z(r) {
  return s(r) ? w(r) : M(r);
}
function K(r) {
  return function(e) {
    e = g(e);
    var o = s(e) ? z(e) : void 0, u = o ? o[0] : e.charAt(0), t = o ? v(o, 1).join("") : e.slice(1);
    return u[r]() + t;
  };
}
var N = K("toUpperCase");
const a = N;
function P(r) {
  return r[0] === "_" ? a(r.slice(1)) : a(r);
}
function G(r) {
  return typeof r == "object" ? Object.entries(r).reduce((e, [o, u]) => {
    const b = o.split(".").map(P).join(".");
    return e[b] = u, e;
  }, {}) : r;
}
export {
  G as default
};
